import { Timer10Icon } from './Timer10Icon';

/**
 * author: Google
 * id BDC89918-A38F-41C6-997E-DE9F779D4435
 * name timer-10
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-10.svg
 * tags
 * - Date / Time 
 */
export const TimerTenIcon = Timer10Icon;
export default TimerTenIcon